import React from 'react';
import PropTypes from 'prop-types';

import { CmdLink } from '@atlas/routing';
import { Label } from '@atlas/ui';

import { camelCase } from 'common/utils';

const Navigation = ({ types }) => {
  if (types.length === 1) {
    return null;
  }

  return (
    <div className="tabs-list">
      {types.map(({ title }) => (
        <CmdLink className="tab-list-item" cmd="signin" key={title} path={camelCase(title)}>
          <Label message={title} />
        </CmdLink>
      ))}
    </div>
  );
};

Navigation.propTypes = {
  types: PropTypes.arrayOf(PropTypes.object),
};

export default Navigation;
